import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { showModal, hideModal } from '../../../../actions/ModalActions';
import { getEventsV2, editEvent } from '../../../../actions/website/entities/EventActions';
import { moveEntity, resetEntities, addEntity, deleteEntityV2 } from '../../../../actions/website/EntityActions';
import { getEventType } from './EventTypes';
import EntityHeader from './EntityHeader';
import DragHandle from '../../../common/ui/DragHandle';
import { togglePage } from '../../../../actions/website/PageActions';
import Tag from '../../common/Tag/Tag';

const Event = SortableElement(({ event, onEdit, onDelete }) => { // eslint-disable-line
  const noPropagate = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };
  const trimmedEventName = event.name.length > 30 ? `${event.name.slice(0, 30)}...` : event.name;
  return (
    <li className="sortable-item editable-entity" onClick={() => onEdit(event)}>
      <div className="col-sm-1">
        <DragHandle tooltip="Drag to reorder" />
      </div>
      <div className="col-sm-10 event-info">
        <div className="type">
          {getEventType(event.type)}
        </div>
        <span className="">
          <span className="event-title">{trimmedEventName}</span>
          <span className="event-visibility">
            {event.public ? (
              <Tag className="tag-primary">
                Public
              </Tag>
            ) : (
              <Tag className="tag-secondary">
                Private
              </Tag>
            )}
          </span>
        </span>
        <p className="description">
          {moment.utc(event.start_at).format('ddd, MMM D, YYYY, h:mm a')}{event.end_at && ` - ${moment.utc(event.end_at).format('h:mm a')}`}<br />
          {event.venue_name}
        </p>
      </div>
      <div className="col-sm-1 entity-actions" onClick={noPropagate}>
        <button onClick={() => onEdit(event)} title="Edit event" className="btn btn-icon with-tooltip no-tooltip-on-mobile" data-tooltip="Edit"><i className="glyphicon glyphicon-pencil" /></button>
      </div>
    </li>
  );
});

Event.propTypes = {
  event: PropTypes.shape({}).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number
};


class Events extends Component {
  componentDidMount() {
    const { getEventEntities } = this.props;
    getEventEntities();
  }

  componentWillUnmount() {
    const { unloadEntities } = this.props;
    unloadEntities();
  }

  render() {
    const { eventEntities, orderedIds, openModal, onEdit, onDelete, page, themeKey, onPageToggle } = this.props;

    return (
      <div>
        {themeKey && (
          <EntityHeader
            onAdd={openModal}
            entityName={'Event'}
            page={page}
            themeKey={themeKey}
            onPageToggle={onPageToggle}
          />
        )}
        <ul className="sortable-list">
          {eventEntities && orderedIds.map((eventId, index) => (
            <Event
              key={index}
              onDelete={onDelete}
              onEdit={onEdit}
              event={eventEntities[eventId]}
              index={index}
            />
          ))}
        </ul>
      </div>
    );
  }
}

Events.propTypes = {
  eventEntities: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getEventEntities: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  page: PropTypes.shape({}),
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func
};

const mapStateToProps = state => ({
  eventEntities: state.website.entities.byId,
  orderedIds: state.website.entities.orderedIds,
  page: state.website.pages.byId[state.website.pages.typeToId.EVENT],
  themeKey: state.wedding.theme.key,
});

const mapDispatchToProps = dispatch => ({
  onSortEnd: ({ oldIndex, newIndex }) => dispatch(moveEntity(oldIndex, newIndex)),
  openModal: () => {
    dispatch(addEntity());
    dispatch(showModal('EVENT_FORM', { websiteEvent: true }, { size: 'md' }));
  },
  getEventEntities: () => dispatch(getEventsV2()),
  onEdit: (event) => {
    dispatch(editEvent(event));
    dispatch(showModal('EVENT_FORM', { websiteEvent: true }, { size: 'md' }));
  },
  onDelete: (event) => {
    const onDeleteEvent = () => {
      dispatch(deleteEntityV2(event)).then(() => {
        dispatch(hideModal());
      });
    };
    dispatch(showModal('DELETE_EVENT', { event, onDeleteEvent }, { size: 'md' }));
  },
  unloadEntities: () => dispatch(resetEntities()),
  onPageToggle: pageId => dispatch(togglePage(pageId))
});

const SortableEvents = SortableContainer(Events);

const EventsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SortableEvents);

export default EventsContainer;



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/entities/EventsV2.jsx
 **/